// extracted by mini-css-extract-plugin
export default {"label":"HfQyT3EK3h_product-carousel","angle":"vmVl0hatFi_product-carousel","textStyle":"Xh29xRdezg_product-carousel"};